import clsx from 'clsx'
import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'

type Card = {
  icon: LucideIcon
  title: string
  description: ReactNode
  descriptionSubdued?: boolean
}

type Props = {
  title: string
  cards: Card[]
  layout: 'horizontal' | 'vertical'
  footerText?: ReactNode
}

export function FirstBillModalCards ({ title, cards, layout, footerText }: Props) {
  const isVertical = layout === 'vertical'

  return (
    <div className='flex flex-col gap-4'>
      <h2 className='heading-md text-left'>{title}</h2>
      <div className={clsx('flex gap-4', { 'flex-col': isVertical, 'flex-row': !isVertical })}>
        {cards.map((card, index) => {
          const IconComponent = card.icon
          return (
            <div
              key={index}
              className={clsx('rounded-2xl border border-gray-200 p-4 flex gap-4', {
                'flex-row items-start': isVertical,
                'flex-col items-center flex-1': !isVertical
              })}
            >
              <div
                className={clsx('bg-gray-100 flex items-center justify-center p-2', {
                  'rounded-lg flex-shrink-0': isVertical,
                  'rounded mb-2': !isVertical
                })}
              >
                <IconComponent className='w-6 h-6 text-gray-500' />
              </div>
              <div
                className={clsx('flex flex-col', {
                  'gap-2 flex-1': isVertical,
                  'items-center': !isVertical
                })}
              >
                <div className={clsx('body-bold', { 'mb-4': !isVertical })}>
                  {card.title}
                </div>
                <div
                  className={clsx('body-sm', {
                    'text-subdued': isVertical && card.descriptionSubdued,
                    'text-center': !isVertical
                  })}
                >
                  {card.description}
                </div>
              </div>
            </div>
          )
        })}
      </div>
      {footerText && (
        <div className='body text-left'>{footerText}</div>
      )}
    </div>
  )
}
